import React, { useState } from 'react';
import '../resources-dialog.css';
import { IRelationalDatabaseInfrastructureResource } from '@elyx-code/definitions';
import { Collapse, IconButton } from '@mui/material';
import EntityDialogSectionHeader from '../../EntityDialogSectionHeader';
import { popupNotification } from '../../../popup-notification';
import { Logger } from '@elyx-code/common-ts-utils';

export interface IRelationalDatabaseSecretsProps {
	resource: IRelationalDatabaseInfrastructureResource;
}

const RelationalDatabaseSecrets: React.FC<IRelationalDatabaseSecretsProps> = ({
	resource,
}) => {
	const [isSectionOpen, setIsSectionOpen] = useState(false);

	if (!resource) {
		return null;
	}

	const secrets = resource.details;
	Logger.log('Databse secrets: ', secrets);

	return (
		<section
			style={{
				display: 'flex',
				flexDirection: 'column',
				paddingBottom: isSectionOpen ? 20 : 0,
			}}
		>
			<EntityDialogSectionHeader
				title='Secrets'
				subtitle={`See the secrets and credentials to connect to your database`}
				hideShowSuffix='the secrets section'
				open={isSectionOpen}
				onToggle={() => setIsSectionOpen(!isSectionOpen)}
				headerEndIcon={
					// Copy all
					<IconButton
						size='small'
						style={{ width: 24, height: 24, fontSize: 16 }}
						onClick={(e) => {
							window.navigator.clipboard.writeText(
								`Endpoint: ${secrets.databaseEndpoint}\nName: ${secrets.databaseName}\nResource ID: ${secrets.databaseId}\nPassword: ${secrets.databasePassword}\nPort: ${secrets.databasePort}\nUsername: ${secrets.databaseUsername}`
							);
							popupNotification({
								text: 'Copied all secrets to clipboard',
								color: 'primary',
							});
						}}
					>
						<i
							className='fa-regular fa-copy'
							style={{
								color: 'rgba(0,0,0,0.54)',
								fontSize: 16,
								cursor: 'pointer',
							}}
						/>
					</IconButton>
				}
				expandIcon={
					<i
						className={`search-statement-dialog__collapse_section-icon fa-solid ${
							isSectionOpen ? 'fa-eye-slash' : 'fa-eye'
						}`}
					/>
				}
			/>

			<Collapse in={isSectionOpen}>
				<div
					style={{
						marginTop: 6,
						display: 'flex',
						flexDirection: 'column',
						gap: 12,
						marginLeft: 80,
						paddingRight: 40,
					}}
				>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<IconButton
							size='small'
							style={{ width: 24, height: 24, fontSize: 16 }}
							onClick={(e) => {
								window.navigator.clipboard.writeText(secrets.databaseEndpoint);
								popupNotification({
									text: 'Copied endpoint to clipboard',
									color: 'primary',
								});
							}}
						>
							<i
								style={{
									color: 'rgba(0,0,0,0.54)',
								}}
								className='fa-regular fa-copy'
							/>
						</IconButton>
						<p
							style={{
								margin: '0px',
								fontSize: '14px',
								fontWeight: 'bold',
							}}
						>
							Endpoint
						</p>
						<p
							style={{
								margin: '0px',
								color: 'rgba(0,0,0,0.7)',
								fontSize: '14px',
							}}
						>
							{secrets.databaseEndpoint}
						</p>
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<IconButton
							size='small'
							style={{ width: 24, height: 24, fontSize: 16 }}
							onClick={(e) => {
								window.navigator.clipboard.writeText(secrets.databaseEndpoint);
								popupNotification({
									text: 'Copied endpoint to clipboard',
									color: 'primary',
								});
							}}
						>
							<i
								style={{
									color: 'rgba(0,0,0,0.54)',
								}}
								className='fa-regular fa-copy'
							/>
						</IconButton>
						<p
							style={{
								margin: '0px',
								fontSize: '14px',
								fontWeight: 'bold',
							}}
						>
							Name
						</p>
						<p
							style={{
								margin: '0px',
								color: 'rgba(0,0,0,0.7)',
								fontSize: '14px',
							}}
						>
							{secrets.databaseName}
						</p>
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<IconButton
							size='small'
							style={{ width: 24, height: 24, fontSize: 16 }}
							onClick={(e) => {
								window.navigator.clipboard.writeText(secrets.databaseId);
								popupNotification({
									text: 'Copied resource ID to clipboard',
									color: 'primary',
								});
							}}
						>
							<i
								style={{
									color: 'rgba(0,0,0,0.54)',
								}}
								className='fa-regular fa-copy'
							/>
						</IconButton>
						<p
							style={{
								margin: '0px',
								fontSize: '14px',
								fontWeight: 'bold',
							}}
						>
							Resource ID
						</p>
						<p
							style={{
								margin: '0px',
								color: 'rgba(0,0,0,0.7)',
								fontSize: '14px',
							}}
						>
							{secrets.databaseId}
						</p>
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<IconButton
							size='small'
							style={{ width: 24, height: 24, fontSize: 16 }}
							onClick={(e) => {
								window.navigator.clipboard.writeText(secrets.databasePassword);
								popupNotification({
									text: 'Copied password to clipboard',
									color: 'primary',
								});
							}}
						>
							<i
								style={{
									color: 'rgba(0,0,0,0.54)',
								}}
								className='fa-regular fa-copy'
							/>
						</IconButton>
						<p
							style={{
								margin: '0px',
								fontSize: '14px',
								fontWeight: 'bold',
							}}
						>
							Password
						</p>
						<p
							style={{
								margin: '0px',
								color: 'rgba(0,0,0,0.7)',
								fontSize: '14px',
							}}
						>
							{secrets.databasePassword}
						</p>
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<IconButton
							size='small'
							style={{ width: 24, height: 24, fontSize: 16 }}
							onClick={(e) => {
								window.navigator.clipboard.writeText(
									secrets.databasePort?.toString()
								);
								popupNotification({
									text: 'Copied port to clipboard',
									color: 'primary',
								});
							}}
						>
							<i
								style={{
									color: 'rgba(0,0,0,0.54)',
								}}
								className='fa-regular fa-copy'
							/>
						</IconButton>
						<p
							style={{
								margin: '0px',
								fontSize: '14px',
								fontWeight: 'bold',
							}}
						>
							Port
						</p>
						<p
							style={{
								margin: '0px',
								color: 'rgba(0,0,0,0.7)',
								fontSize: '14px',
							}}
						>
							{secrets.databasePort}
						</p>
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<IconButton
							size='small'
							style={{ width: 24, height: 24, fontSize: 16 }}
							onClick={(e) => {
								window.navigator.clipboard.writeText(secrets.databaseUsername);
								popupNotification({
									text: 'Copied username to clipboard',
									color: 'primary',
								});
							}}
						>
							<i
								style={{
									color: 'rgba(0,0,0,0.54)',
								}}
								className='fa-regular fa-copy'
							/>
						</IconButton>
						<p
							style={{
								margin: '0px',
								fontSize: '14px',
								fontWeight: 'bold',
							}}
						>
							Username
						</p>
						<p
							style={{
								margin: '0px',
								color: 'rgba(0,0,0,0.7)',
								fontSize: '14px',
							}}
						>
							{secrets.databaseUsername}
						</p>
					</div>
				</div>
			</Collapse>
		</section>
	);
};

export default RelationalDatabaseSecrets;
